var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Inline, Inset, Stack } from 'syf-component-library/ui/spacing';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { colors } from '../../../theme';
import { StyledBorder, StyledFlex, StyledText } from '../../subcomponents';
import { StyledRadio, StyledRadioOptionsCard, StyledRadioOptionsContent, StyledTag } from './subcomponents';
var RadioOptionCard = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, icon = _a.icon, id = _a.id, name = _a.name, title = _a.title, _c = _a.tagBackground, tagBackground = _c === void 0 ? colors.syfYellow : _c, tagContent = _a.tagContent, body = _a.body, footer = _a.footer, onChange = _a.onChange, value = _a.value, rest = __rest(_a, ["checked", "icon", "id", "name", "title", "tagBackground", "tagContent", "body", "footer", "onChange", "value"]);
    var handleChange = function () {
        if (typeof onChange === 'function') {
            onChange(value);
        }
    };
    var renderComponent = (_jsx(StyledRadioOptionsContent, __assign({ direction: "column" }, { children: _jsxs(Inset, __assign({ vertical: "xsmall" }, { children: [_jsxs(StyledFlex, __assign({ justifyContent: "space-between" }, { children: [_jsx(StyledText, __assign({ size: "large", weight: "bold", lineHeight: icon ? 1 : 1.2 }, { children: title })), _jsx(RenderIf, __assign({ condition: !!tagContent }, { children: _jsx(StyledTag, { backgroundColor: tagBackground, content: tagContent }) }))] })), _jsx(Stack, { size: "medium" }), _jsx(StyledBorder, {}), _jsx(Inset, __assign({ top: "small" }, { children: body }))] })) })));
    return (_jsx(StyledRadioOptionsCard, __assign({ checked: checked }, rest, { children: _jsxs(Inset, __assign({ all: "medium" }, { children: [icon ? (_jsxs(StyledFlex, { children: [icon, _jsx(Inline, { size: "small" }), renderComponent] })) : (_jsx(StyledRadio, __assign({ id: id, name: name, value: value, checked: checked, onChange: handleChange }, { children: renderComponent }))), footer && (_jsxs(_Fragment, { children: [_jsx(Stack, {}), footer, _jsx(Stack, { size: "xsmall" })] }))] })) })));
};
export default RadioOptionCard;
//# sourceMappingURL=index.js.map